module.exports = __webpack_public_path__ + "static/media/default-company-logo.a963a5ab.png";